/**
 * What a bill's state is, said in full.
 *
 * Cancellation and payment are two different facts and a bill can carry
 * both. Showing only one of them was actively misleading: a cancelled bill
 * that had been paid rendered as a plain green "paid", which is the
 * healthiest thing the interface can say about an invoice that is void and
 * owes somebody their money back.
 *
 * So cancellation leads -- in the danger colour, because it is an exception
 * and not a resting state -- and the payment is reported beside it.
 */
export function BillStatus({ status, paidAt }: {
  status: 'draft' | 'final' | 'cancelled'
  paidAt?: string | null
}) {
  if (status === 'cancelled') {
    return (
      <span className="badge-pair">
        <span className="badge cancelled status-badge">cancelled</span>
        {paidAt ? (
          <span className="badge was-paid status-badge"
            title="Payment was taken before this bill was cancelled — a refund is owed.">
            paid · refund due
          </span>
        ) : null}
      </span>
    )
  }
  if (status === 'final') {
    return paidAt
      ? <span className="badge final status-badge">paid</span>
      : <span className="badge final-unpaid status-badge">unpaid</span>
  }
  return <span className="badge draft status-badge">draft</span>
}
